import React from "react";
import { Dropdown, Nav, Navbar } from "rsuite";
import "./Navbar.scss";
import logo from "assets/logo.png";
import { IoIosArrowBack, IoIosHome, IoIosSettings } from "react-icons/io";
import { Link } from "react-router-dom";

import { PanelUserAccessScope } from "@bprotsyk/aso-core";

export enum NavbarTab {
  INDEX = 'index',
  CONSTRUCTOR_FLASH = 'constructor_flash',
  AUTH = 'auth',
  CAPS = 'caps',
  OFFERS = 'offers',
  DOMAINS = 'domains',
  APPS_INFO = 'app-info',
  APPS = 'apps',
  CLICK_DATA = 'click-data',
  OFFER_LISTS = 'offer-lists',
  SETTINGS = 'settings'
}

interface AppHubNavbarProps {
  tab: NavbarTab;
  // config: DefaultConfig,
  // configs: DefaultConfig[],
  // onConfigChange: (config: DefaultConfig) => void
}

export default (props: AppHubNavbarProps) => {
  let { tab } = props;
  const rawRoles = localStorage.getItem('userRole');
  let parsedRoles: number[] = [];
  try {
    const raw = rawRoles ? JSON.parse(rawRoles) as any[] : [];
    parsedRoles = Array.isArray(raw) ? raw.map((r) => Number(r)) : [];
  } catch (_) {
    parsedRoles = [];
  }
  const isAdmin = parsedRoles.includes(PanelUserAccessScope.ADMIN as unknown as number);
  const isManager = parsedRoles.includes(PanelUserAccessScope.MANAGER as unknown as number);
  const isDeployer = parsedRoles.includes(PanelUserAccessScope.DEPLOYER as unknown as number);
  const isTester = parsedRoles.includes(PanelUserAccessScope.TESTER as unknown as number);

  // let dropdownItems: any[] = []
  // configs.forEach((c) => {
  //   if (c.id == config?.id) return

  //   dropdownItems.push(
  //     <Dropdown.Item eventKey={c?.id}>#{c?.id} <code>{c?.bundle}</code></Dropdown.Item>
  //   )
  // })

  return (
    <Navbar>
      <Navbar.Brand className="brand">
        <img src={logo} className="logo" />
      </Navbar.Brand>
      <Nav activeKey={tab.toString()}>
        {(isAdmin || isTester) && (
          <Nav.Item href="apps" eventKey={NavbarTab.APPS.toString()}>
            Додатки
          </Nav.Item>
        )}
        {(isAdmin || isDeployer) && (
          <Nav.Item href="domains" eventKey={NavbarTab.DOMAINS.toString()}>
            Домени
          </Nav.Item>
        )}
        {isAdmin && (
          <Nav.Item href="click-data" eventKey={NavbarTab.CLICK_DATA.toString()}>
            Кліки
          </Nav.Item>
        )}
        {isAdmin && (
          <Nav.Item href="offers" eventKey={NavbarTab.OFFERS.toString()}>
            Оффери
          </Nav.Item>
        )}
        {isAdmin && (
          <Nav.Item href="offer-lists" eventKey={NavbarTab.OFFER_LISTS.toString()}>
            Списки офферів
          </Nav.Item>
        )}
      </Nav>

      {isAdmin && (
        <Nav pullRight>
          <Nav.Item href="settings" eventKey={NavbarTab.SETTINGS.toString()} className="settings-icon">
            <IoIosSettings size={18} />
          </Nav.Item>
        </Nav>
      )}
    </Navbar>
  );
};
